import {
  setUnauthorizedHandler,
  setSubscriptionRequiredHandler,
  setAccessToken,
  clearAccessToken,
} from "./apiClient";
import clinicAPI from "./clinicApi";
import authAPI from "./authApi";

export { getApiErrorMessage } from "../utils/apiError";

const services = {
  setUnauthorizedHandler,
  setSubscriptionRequiredHandler,
  persistAccessToken: setAccessToken,
  clearAccessToken,
  clinicAPI,
  authAPI,
};

export default services;
